import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, history } from 'umi';
import { Text, Image, BackImageEnum, Card, Icon, Divider, Button, Modal } from '@digitalc/dxp-ui';
import { Input, Picker } from 'antd-mobile';
import { Dropdown, Radio } from 'antd';
import styled from 'styled-components';
import Header from '@/pages/PointShop/Header';
import { BaseSpin, Clickable } from '@/components';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';

import bgPointExchangePNG from '@/assets/images/point/bg_point_exchange.png';
import exchangeNoDataPNG from '@/assets/images/point/exchaneg_noData.png';
import exchangeFailPNG from '@/assets/images/point/exchange_fail.png';
import exchangeSuccessPNG from '@/assets/images/point/exchange_success.png';
import { onHistoryPush, goBack, getThemeImgByKey, numberFormat } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import styles from './index.less';

const RadioContainer = styled.div`
  margin-bottom: ${props => props.$dxpToken.spacingGapSm / 100}rem;
  .ant-radio-checked .ant-radio-inner {
    background-color: ${props => props.$dxpToken.colorBackgroundActive};
    border-color: ${props => props.$dxpToken.colorBackgroundActive};
  }
`;
const InputContainer = styled.div`
  input {
    font-family: ${props => props.$dxpToken.fontFamilyPrimaryBold};
    font-size: ${props => props.$dxpToken.fontSizeMobileTitleT23 / 100}rem;
    color: ${props => props.$dxpToken.colorTextNeutral};
    font-weight: 700;
    min-height: 1.25em;
    line-height: 1.25;
    letter-spacing: 0.002rem;
  }
`;

const PointExchange = props => {
  const {
    dispatch,
    loadingRule,
    loading,
    pointExchangeRuleList,
    pointExchangeRule,
    isWeb,
    dxpToken,
  } = props;
  const GCPI18n = useGCPI18n();

  useResponsive();
  // const [showConfirm, setShowConfirm] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false); // web才有成功弹窗 h5是调整成功页面
  const [showPicker, setShowPicker] = useState(false);
  const [currentPoints, setCurrentPoints] = useState(0); // 当前已有的积分余额
  const [exchangeFailTips, setExchangeFailTips] = useState('lb_points_exchange_min_tips');
  const [initialLoading, setInitialLoading] = useState(true); // 初始加载状态
  const [selectedDisplayOrder, setSelectedDisplayOrder] = useState(null); // 当前选中的分组
  const [groupedRules, setGroupedRules] = useState([]); // 分组后的数据
  const inputRef = useRef(null);
  const { notNewPage, pageCode } = history.location.query;
  const effectivePageCode = pageCode || window.localStorage.getItem('GCP_POINT_HOME_PAGE_CODE');

  // 将 pointExchangeRuleList 按照 displayOrder 分组
  const groupByDisplayOrder = list => {
    if (!list || list.length === 0) return [];

    const groups = {};
    list.forEach(item => {
      const key = item.displayOrder || 0; // 如果没有 displayOrder，默认分到一组
      if (!groups[key]) {
        groups[key] = {
          displayOrder: key,
          categoryName: '',
          exchangeRuleList: [],
          // 每个分组的数据
          ledgerAmount: '',
          pickerValue: [],
          selectedRule: null,
          // 每个分组的余额数据
          ledgerBalanceDisplay: '',
          ledgerBalanceUnit: '',
          productId: null,
        };
      }
      groups[key].exchangeRuleList.push(item);
    });

    // 设置每个分组的初始规则
    Object.values(groups).forEach(group => {
      if (group.exchangeRuleList.length > 0) {
        const firstItem = group.exchangeRuleList[0];
        group.pickerValue = [firstItem.acctResCode];
        group.selectedRule = firstItem;
        group.categoryName =
          group.exchangeRuleList.find(item => item.categoryName)?.categoryName || '';
      }
    });

    return Object.values(groups).sort((a, b) => a.displayOrder - b.displayOrder);
  };
  const updateGroupData = (displayOrder, updates) => {
    setGroupedRules(prev =>
      prev.map(group => (group.displayOrder === displayOrder ? { ...group, ...updates } : group)),
    );
  };
  const queryLedgerBalance = (displayOrder, acctResCode) => {
    if (acctResCode) {
      dispatch({
        type: 'pointShop/queryLedgerBalance',
        payload: acctResCode,
      }).then(res => {
        // 更新指定分组的余额数据
        updateGroupData(displayOrder, {
          ledgerBalanceDisplay: res?.ledgerBalanceDisplay || '',
          ledgerBalanceUnit: res?.ledgerBalanceUnit || '',
          productId: res?.productId ?? null,
        });
      });
    }
  };
  // 当 pointExchangeRuleList 变化时，重新计算分组并初始化数据
  useEffect(() => {
    if (pointExchangeRuleList && pointExchangeRuleList.length > 0) {
      const grouped = groupByDisplayOrder(pointExchangeRuleList);
      setGroupedRules(grouped);

      // 为每个分组都请求一次余额
      grouped.forEach(group => {
        if (group.selectedRule?.acctResCode) {
          queryLedgerBalance(group.displayOrder, group.selectedRule.acctResCode);
        }
      });

      // 默认选中第一个分组
      if (selectedDisplayOrder === null && grouped.length > 0) {
        setSelectedDisplayOrder(grouped[0].displayOrder);
        // 设置全局 pointExchangeRule
        if (grouped[0].selectedRule) {
          dispatch({
            type: 'pointShop/updateState',
            payload: {
              pointExchangeRule: grouped[0].selectedRule,
            },
          });
        }
      }
    }
  }, [pointExchangeRuleList]);

  // 更新指定分组的数据

  // 计算指定分组的兑换积分
  const calculateExchangePoints = group => {
    const { ledgerAmount, selectedRule } = group;
    if (ledgerAmount && selectedRule?.valueInterval) {
      const tempPoints =
        (ledgerAmount / selectedRule?.valueInterval) * selectedRule?.pointValueDisplay;
      // 保持与 pointValueDisplay 相同的精度
      const pointValueStr = String(selectedRule?.pointValueDisplay);
      const decimalPlaces = pointValueStr.includes('.') ? pointValueStr.split('.')[1].length : 0;
      return tempPoints.toFixed(decimalPlaces);
    }
    return 0;
  };

  // 获取当前选中分组的 Picker columns
  const getCurrentGroupColumn = () => {
    const currentGroup = groupedRules.find(group => group.displayOrder === selectedDisplayOrder);
    if (!currentGroup || currentGroup.exchangeRuleList.length === 0) return [[]];
    return [
      currentGroup.exchangeRuleList.map(item => ({
        value: item.acctResCode,
        label: item.acctResName,
      })),
    ];
  };

  // 当选中分组变化时，更新全局 pointExchangeRule
  useEffect(() => {
    if (selectedDisplayOrder !== null) {
      const currentGroup = groupedRules.find(group => group.displayOrder === selectedDisplayOrder);
      if (currentGroup && currentGroup.selectedRule) {
        dispatch({
          type: 'pointShop/updateState',
          payload: {
            pointExchangeRule: currentGroup.selectedRule,
          },
        });
      }
    }
  }, [selectedDisplayOrder]);
  const queryPoints = () => {
    dispatch({
      type: 'pointShop/getPointDetailDXP',
      payload: {
        scopes: 'LATEST_EXPIRING_POINT',
      },
    }).then(res => {
      if (res) {
        const pointObj = Array.isArray(res)
          ? res?.find(item => item.pointAccountTypeCode === '1')
          : res;
        setCurrentPoints(pointObj?.usablePointDisplay || 0);
      }
    });
  };
  useEffect(() => {
    // 页面加载自动聚焦
    inputRef.current?.focus();
    dispatch({
      type: 'pointShop/queryExchangeRule',
    }).finally(() => {
      setInitialLoading(false);
    });
    queryPoints();
    if (effectivePageCode) {
      // 将初始化的pageCode存储起来，后面兑换成功后会返回首页，此时会使用pageCode
      // 同时写入localStorage，防止页面刷新（如PullToRefresh的location.replace）后store重置导致丢失
      window.localStorage.setItem('GCP_POINT_HOME_PAGE_CODE', effectivePageCode);
      dispatch({
        type: 'pointShop/updateState',
        payload: {
          pbPageCode: effectivePageCode,
        },
      });
    }
  }, []);
  useEffect(() => {
    // 延迟聚焦，确保页面完全加载
    const timer = setTimeout(() => {
      if (inputRef.current) {
        // 方法1: 使用 antd-mobile 的 focus 方法
        inputRef.current.focus();

        // 方法2: 如果方法1不生效，直接操作原生 input
        const nativeInput = inputRef.current.nativeElement;
        if (nativeInput) {
          nativeInput.focus();
          // 触发点击事件，确保键盘弹出
          nativeInput.click();
        }
      }
    }, 300); // 延迟300ms，避免页面加载时被打断

    return () => clearTimeout(timer);
  }, []);

  const handleExchangePoints = () => {
    if (selectedDisplayOrder === null) return;
    const currentGroup = groupedRules.find(g => g.displayOrder === selectedDisplayOrder);
    if (!currentGroup) return;

    dispatch({
      type: 'pointShop/exchangePoints',
      payload: {
        acctResCode: currentGroup.selectedRule?.acctResCode,
        accountAmount: currentGroup.ledgerAmount,
        productId: currentGroup.productId,
      },
    }).then(res => {
      // setShowConfirm(false);
      queryPoints();
      if (res.resultCode === '0') {
        trackSensors('reward_databank', {
          category: 'reward_databank',
          action: 'system_response',
          label: 'convert - success',
        });
        if (isWeb) {
          setShowSuccessModal(true);
          queryLedgerBalance(selectedDisplayOrder, currentGroup.selectedRule?.acctResCode);
          queryPoints();
          return;
        }
        onHistoryPush(
          '/pointshop/successfulNew',
          {},
          {
            title: GCPI18n('lb_points_exchange_success_title'),
            content: GCPI18n('lb_points_exchange_success_tips'),
            btnText: GCPI18n('btn_points_exchange_success'),
          },
        );
      } else {
        trackSensors('reward_databank', {
          category: 'reward_databank',
          action: 'system_response',
          label: 'convert - failed',
        });
        setShowFailModal(true);
      }
    });
  };
  const handleExchangeClick = () => {
    trackSensors('reward_databank', {
      category: 'reward_databank',
      action: 'button_click',
      label: 'convert',
    });
    if (selectedDisplayOrder === null) return;
    const currentGroup = groupedRules.find(g => g.displayOrder === selectedDisplayOrder);
    if (!currentGroup) return;

    const {
      ledgerAmount,
      selectedRule,
      ledgerBalanceDisplay: groupLedgerBalanceDisplay,
    } = currentGroup;

    if (
      !ledgerAmount ||
      (selectedRule?.minValue && Number(ledgerAmount) < Number(selectedRule?.minValue))
    ) {
      setExchangeFailTips('lb_points_exchange_min_tips');
      setShowFailModal(true);
    } else if (selectedRule?.maxValue && Number(ledgerAmount) > Number(selectedRule?.maxValue)) {
      setExchangeFailTips('lb_points_exchange_max_tips');
      setShowFailModal(true);
    } else if (Number(ledgerAmount) > Number(groupLedgerBalanceDisplay)) {
      setExchangeFailTips('lb_points_exchange_more_tips');
      setShowFailModal(true);
    } else if (
      selectedRule?.valueInterval &&
      Number(ledgerAmount) % Number(selectedRule?.valueInterval) !== 0
    ) {
      setExchangeFailTips('lb_points_exchange_interval_tips');
      setShowFailModal(true);
    } else {
      setExchangeFailTips('lb_points_exchange_fail_tips');
      // setShowConfirm(true);
      handleExchangePoints();
    }
  };
  const handlePickRule = displayOrder => {
    const group = groupedRules.find(g => g.displayOrder === displayOrder);
    if (group && group.exchangeRuleList?.length > 1 && !isWeb) {
      setShowPicker(true);
    }
  };

  const handleChangeAmount = (value, displayOrder) => {
    // 过滤非数字字符，只保留0-9
    const sanitizedValue = value.replace(/[^0-9]/g, '');

    // 移除前导零
    let finalValue = sanitizedValue;
    if (sanitizedValue.length > 1) {
      finalValue = sanitizedValue.replace(/^0+/, '') || '0';
    }

    updateGroupData(displayOrder, { ledgerAmount: finalValue });
  };

  const handleChangeRule = v => {
    if (selectedDisplayOrder === null) return;
    let selectedValue = null;
    if (isWeb) {
      selectedValue = v?.key;
    } else {
      selectedValue = v?.[0];
    }
    // 从当前选中分组的 exchangeRuleList 中查找
    const currentGroup = groupedRules.find(g => g.displayOrder === selectedDisplayOrder);
    const filterRule = currentGroup?.exchangeRuleList?.find(
      item => item.acctResCode === selectedValue,
    );
    if (filterRule) {
      dispatch({
        type: 'pointShop/updateState',
        payload: {
          pointExchangeRule: filterRule,
        },
      });
      updateGroupData(selectedDisplayOrder, {
        pickerValue: [selectedValue],
        selectedRule: filterRule,
      });
      queryLedgerBalance(selectedDisplayOrder, filterRule.acctResCode);
    }
    setShowPicker(false);
  };

  const handleChangeGroup = displayOrder => {
    // 切换到不同分组时，清空之前选中分组的数据， 避免数据混淆
    if (selectedDisplayOrder !== null && selectedDisplayOrder !== displayOrder) {
      updateGroupData(selectedDisplayOrder, { ledgerAmount: '' });
    }
    setSelectedDisplayOrder(displayOrder);
  };
  const failModalBody = (
    <div className={styles.tipBody}>
      <Image
        src={getThemeImgByKey('genericWarning') || exchangeFailPNG}
        imageSize={208}
        style={{ aspectRatio: 'unset', objectFit: 'cover', objectPosition: 'center' }}
      />
      <Text
        breakpoint="Mobile"
        size="TitleT23Bold"
        style={{ color: dxpToken.colorTextNeutral }}
        className={styles.tipTitle}
      >
        {GCPI18n('lb_common_fail_title')}
      </Text>
      <Text
        breakpoint="Mobile"
        size="ContentC14Regular"
        style={{ color: dxpToken.colorTextNeutral }}
      >
        {GCPI18n(exchangeFailTips, {
          min: pointExchangeRule?.minValue,
          max: pointExchangeRule?.maxValue,
          interval: pointExchangeRule?.valueInterval,
        })}
      </Text>
    </div>
  );
  return (
    <div className={styles.pageWrap}>
      <Header
        title={GCPI18n('lb_points_exchange_header')}
        titleFontFamily="Roboto"
        goHome={goBack}
        notNewPage={notNewPage || false}
        hideClose
      />
      <BaseSpin spinning={loadingRule || initialLoading}>
        {!initialLoading && groupedRules && groupedRules?.length > 0 ? (
          <>
            <div className={styles.content}>
              <div className={styles.topWrap}>
                <div>
                  <Text
                    breakpoint="Mobile"
                    size={isWeb ? 'TitleT21Bold' : 'TitleT23Bold'}
                    style={{ color: dxpToken.colorTextNeutral }}
                  >
                    {GCPI18n('tip_points_exchange_title')}
                  </Text>
                </div>
                <Image
                  src={getThemeImgByKey('depositToMyPoints') || bgPointExchangePNG}
                  radio={BackImageEnum.whRadio1}
                  imageSize={80}
                  style={{ height: '80px', objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <div className={styles.centerWrap}>
                {groupedRules.map((group, index) => {
                  const isSelected = group.displayOrder === selectedDisplayOrder;
                  const {
                    selectedRule,
                    ledgerAmount: groupLedgerAmount,
                    exchangeRuleList,
                    ledgerBalanceDisplay: groupLedgerBalanceDisplay,
                    ledgerBalanceUnit: groupLedgerBalanceUnit,
                  } = group;
                  const exchangePoints = calculateExchangePoints(group);

                  return (
                    <>
                      <div
                        key={`group-${group.displayOrder}-${index}`}
                        className={styles.groupWrap}
                      >
                        {/* Radio 选择器 */}
                        {groupedRules.length > 1 && (
                          <RadioContainer $dxpToken={dxpToken}>
                            <Radio
                              checked={isSelected}
                              onChange={() => handleChangeGroup(group.displayOrder)}
                            >
                              <Text
                                breakpoint="Mobile"
                                size="ContentC14Bold"
                                style={{ color: dxpToken.colorTextNeutral }}
                              >
                                {group.categoryName}
                              </Text>
                            </Radio>
                          </RadioContainer>
                        )}
                        {/* 兑换规则内容 */}
                        <Clickable
                          onClick={() => {
                            handleChangeGroup(group.displayOrder);
                          }}
                        >
                          <Card
                            style={{
                              backgroundColor: dxpToken.colorBackgroundSubtle,
                              padding: dxpToken.spacingGapMd,
                            }}
                            className={styles.fromWrap}
                          >
                            <div>
                              {!isWeb ? (
                                <Text
                                  breakpoint="Mobile"
                                  size="ContentC12Bold"
                                  style={{
                                    color: dxpToken.colorTextNeutral,
                                    cursor:
                                      isSelected && exchangeRuleList?.length > 1
                                        ? 'pointer'
                                        : 'not-allowed',
                                  }}
                                  onClick={() => handlePickRule(group.displayOrder)}
                                >
                                  {GCPI18n('lb_points_exchange_from')} {selectedRule?.acctResName}{' '}
                                  {exchangeRuleList?.length > 1 && (
                                    <Icon
                                      size={12}
                                      type="icon-a-Arrow-Down"
                                      style={{
                                        marginRight: `${dxpToken.spacingGapXs / 100}rem`,
                                        color: dxpToken.colorIconSubtle,
                                      }}
                                    />
                                  )}
                                </Text>
                              ) : (
                                <Dropdown
                                  disabled={!isSelected}
                                  overlayClassName={styles.dropdownWrap}
                                  menu={{
                                    items: exchangeRuleList,
                                    selectedKeys: group.pickerValue,
                                    onClick: handleChangeRule,
                                  }}
                                  trigger={['click']}
                                >
                                  <Text
                                    breakpoint="Mobile"
                                    size="ContentC12Bold"
                                    style={{
                                      color: dxpToken.colorTextNeutral,
                                      cursor: isSelected ? 'pointer' : 'not-allowed',
                                    }}
                                  >
                                    {GCPI18n('lb_points_exchange_from')} {selectedRule?.acctResName}{' '}
                                    {exchangeRuleList?.length > 1 && (
                                      <Icon
                                        size={12}
                                        type="icon-a-Arrow-Down"
                                        style={{
                                          marginRight: `${dxpToken.spacingGapXs / 100}rem`,
                                          color: dxpToken.colorIconSubtle,
                                        }}
                                      />
                                    )}
                                  </Text>
                                </Dropdown>
                              )}
                              <InputContainer $dxpToken={dxpToken} className={styles.inputWrap}>
                                {/* 对于B（本金）类型的单位展示在前，否则在后 */}
                                {selectedRule?.acctType === 'B' && (
                                  <Text
                                    breakpoint="Mobile"
                                    size="TitleT21Bold"
                                    style={{ color: dxpToken.colorTextNeutral }}
                                  >
                                    {selectedRule?.acctUnit}
                                  </Text>
                                )}
                                <Input
                                  ref={isSelected ? inputRef : null}
                                  placeholder="0"
                                  autoFocus={isSelected}
                                  value={groupLedgerAmount}
                                  type="tel"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  autoComplete="off"
                                  onChange={v => handleChangeAmount(v, group.displayOrder)}
                                />
                                {selectedRule?.acctType !== 'B' && (
                                  <Text
                                    breakpoint="Mobile"
                                    size="TitleT21Bold"
                                    style={{ color: dxpToken.colorTextNeutral }}
                                  >
                                    {selectedRule?.acctUnit}
                                  </Text>
                                )}
                              </InputContainer>
                              <Text
                                breakpoint="Mobile"
                                size="ContentC12Regular"
                                style={{ color: dxpToken.colorTextSubtle }}
                              >
                                {GCPI18n('lb_poins_current_balance')}{' '}
                                {selectedRule?.acctType === 'B' && groupLedgerBalanceUnit}
                                {numberFormat(groupLedgerBalanceDisplay || 0)}
                                {selectedRule?.acctType !== 'B' && groupLedgerBalanceUnit}
                              </Text>
                            </div>
                            <span className={styles.iconWrap}>
                              <span
                                className={styles.icon}
                                style={{ backgroundColor: dxpToken.colorBackgroundSubtle }}
                              >
                                <Icon
                                  size={16}
                                  type="icon-a-SortingDown"
                                  style={{ color: dxpToken.colorTextNeutral }}
                                />
                              </span>
                            </span>
                          </Card>
                          <Card
                            style={{
                              backgroundColor: dxpToken.colorBackgroundActiveWeakInverse,
                              border: 'none',
                            }}
                          >
                            <Text
                              breakpoint="Mobile"
                              size="ContentC12Bold"
                              style={{ color: dxpToken.colorTextNeutral }}
                            >
                              {GCPI18n('lb_points_exchange_to')}{' '}
                              {GCPI18n('lb_points_exchange_gb_coins')}
                            </Text>
                            <div className={styles.getPointWrap}>
                              <Text
                                breakpoint="Mobile"
                                size="TitleT23Bold"
                                style={{ color: dxpToken.colorTextNeutral }}
                                className={styles.amount}
                              >
                                {numberFormat(exchangePoints || 0)}
                              </Text>
                              <Text
                                breakpoint="Mobile"
                                size="TitleT21Bold"
                                style={{ color: dxpToken.colorTextNeutral }}
                              >
                                {GCPI18n('lb_points_exchange_gb_coins')}
                              </Text>
                            </div>
                            <Text
                              breakpoint="Mobile"
                              size="ContentC12Regular"
                              style={{ color: dxpToken.colorTextSubtle }}
                            >
                              {GCPI18n('lb_poins_current_balance')} {numberFormat(currentPoints)}{' '}
                              {GCPI18n('lb_points_exchange_gb_coins')}
                            </Text>
                          </Card>
                        </Clickable>
                      </div>
                      {index !== groupedRules.length - 1 &&
                        (isWeb ? (
                          <Divider
                            style={{
                              margin: '0.24rem 0rem',
                              borderBottom: `1px solid ${dxpToken.colorBorderDivider}`,
                            }}
                          />
                        ) : (
                          <div
                            className={styles.divider}
                            style={{ backgroundColor: dxpToken.colorBackgroundSubtle }}
                          />
                        ))}
                    </>
                  );
                })}
              </div>
              <Divider style={{ borderBottom: `1px solid ${dxpToken.colorBorderDivider}` }} />
              <Text
                breakpoint="Mobile"
                size="ContentC12Regular"
                style={{ color: dxpToken.colorTextSubtle }}
                className={styles.tips}
              >
                {GCPI18n('tip_points_exchange_tips')}
              </Text>
            </div>
            <div
              className={styles.pageBottom}
              style={{
                bottom: 0,
              }}
            >
              <Button
                type="primary"
                loading={loading}
                onClick={handleExchangeClick}
                style={{ width: '100%' }}
              >
                {GCPI18n('btn_points_exchange_convert')}
              </Button>
            </div>

            <Modal
              size="50%"
              breakpoint="Mobile"
              open={showFailModal}
              className={isWeb ? styles.webPointsModal : ''}
              onCancel={() => setShowFailModal(false)}
              footer={(
                <Button
                  type="primary"
                  onClick={() => setShowFailModal(false)}
                  style={{ width: '100%' }}
                >
                  {GCPI18n('btn_common_got_it')}
                </Button>
              )}
            >
              {failModalBody}
            </Modal>
            <Modal
              size="50%"
              breakpoint="Mobile"
              open={showSuccessModal}
              className={styles.webPointsModal}
              onCancel={() => setShowSuccessModal(false)}
              footer={(
                <Button
                  type="primary"
                  onClick={() => setShowSuccessModal(false)}
                  style={{ width: '100%' }}
                >
                  {GCPI18n('btn_common_awesome')}
                </Button>
              )}
            >
              <div className={styles.tipBody}>
                <Image
                  src={getThemeImgByKey('genericSuccess') || exchangeSuccessPNG}
                  imageSize={208}
                  style={{ aspectRatio: 'unset', objectFit: 'cover', objectPosition: 'center' }}
                />
                <Text
                  breakpoint="Mobile"
                  size="TitleT23Bold"
                  style={{ color: dxpToken.colorTextNeutral }}
                  className={styles.tipTitle}
                >
                  {GCPI18n('lb_common_success_title')}
                </Text>
                <Text
                  breakpoint="Mobile"
                  size="ContentC14Regular"
                  style={{ color: dxpToken.colorTextNeutral }}
                >
                  {GCPI18n('lb_points_exchange_success_tips')}
                </Text>
              </div>
            </Modal>
            <Picker
              visible={showPicker}
              columns={getCurrentGroupColumn()}
              value={
                selectedDisplayOrder !== null
                  ? groupedRules.find(g => g.displayOrder === selectedDisplayOrder)?.pickerValue ||
                    []
                  : []
              }
              defaultValue={
                selectedDisplayOrder !== null
                  ? groupedRules.find(g => g.displayOrder === selectedDisplayOrder)?.pickerValue ||
                    []
                  : []
              }
              popupClassName={styles.pickerWrap}
              onClose={() => setShowPicker(false)}
              cancelText={(
                <Text
                  breakpoint="Mobile"
                  size="ContentC12Regular"
                  style={{ color: dxpToken.colorTextNeutral }}
                >
                  {GCPI18n('btn_common_cancel')}
                </Text>
              )}
              confirmText={(
                <div className={styles.confirmBtn}>
                  <Button type="primary" style={{ width: '100%' }}>
                    {GCPI18n('btn_common_confirm')}
                  </Button>
                </div>
              )}
              onConfirm={handleChangeRule}
            />
          </>
        ) : (
          !initialLoading &&
          !loadingRule &&
          (!pointExchangeRuleList || pointExchangeRuleList.length === 0) && (
            <div className={styles.noData}>
              <Image
                src={getThemeImgByKey('genericEmpty') || exchangeNoDataPNG}
                imageSize={208}
                style={{ aspectRatio: 'unset', objectFit: 'cover', objectPosition: 'center' }}
              />
              <Text
                breakpoint="Mobile"
                size="TitleT23Bold"
                style={{ color: dxpToken.colorTextNeutral }}
              >
                {GCPI18n('lb_points_exchange_no_data_title')}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                style={{ color: dxpToken.colorTextNeutral }}
              >
                {GCPI18n('lb_common_to_try_again')}
              </Text>
              <Button type="primary" onClick={() => goBack()} style={{ width: '100%' }}>
                {GCPI18n('btn_common_got_it')}
              </Button>
            </div>
          )
        )}
      </BaseSpin>
    </div>
  );
};

PointExchange.propTypes = {
  dispatch: PropTypes.func,
  loadingRule: PropTypes.bool,
  loading: PropTypes.bool,
  pointExchangeRuleList: PropTypes.array,
  pointExchangeRule: PropTypes.shape({
    minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valueInterval: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isWeb: PropTypes.bool,
  dxpToken: PropTypes.shape({
    spacingGapMd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingGapXs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingGapSm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    colorIconSubtle: PropTypes.string,
    colorBorderDivider: PropTypes.string,
    colorTextNeutral: PropTypes.string,
    colorTextSubtle: PropTypes.string,
    colorBackgroundSubtle: PropTypes.string,
    colorBackgroundActive: PropTypes.string,
    fontFamilyPrimaryBold: PropTypes.string,
    fontSizeMobileTitleT23: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default connect(({ pointShop, loading, index }) => ({
  ...pointShop,
  isWeb: index.isWeb,
  loadingRule: loading.effects['pointShop/queryExchangeRule'] || false,
  loading: loading.effects['pointShop/exchangePoints'] || false,
  dxpToken: index.dxpToken,
}))(PointExchange);
